var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: [
        { "input-group": _vm.hasIcon },
        { "has-right-slot": _vm.addonRightIcon || this.$slots.addonRight },
        { "has-error": _vm.error },
        { "input-group-focus": _vm.focused },
        { "has-label": _vm.label || _vm.$slots.label },
        { "has-success": !_vm.error && _vm.touched && _vm.hadError }
      ]
    },
    [
      _vm._t("label", [
        _vm.label
          ? _c(
              "label",
              { class: _vm.labelClasses, attrs: { for: _vm.forInput } },
              [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
                _vm.required ? _c("span", [_vm._v("*")]) : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.addonLeftIcon || _vm.$slots.addonLeft
        ? _c(
            "span",
            { staticClass: "input-group-addon input-group-prepend" },
            [_vm._t("addonLeft", [_c("i", { class: _vm.addonLeftIcon })])],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", [
        _vm.type === "textarea"
          ? _c(
              "textarea",
              _vm._g(
                _vm._b(
                  {
                    staticClass: "form-control",
                    class: [
                      { valid: _vm.value && !_vm.error },
                      _vm.inputClasses
                    ],
                    attrs: { "aria-describedby": "addon-right addon-left" }
                  },
                  "textarea",
                  _vm.$attrs,
                  false
                ),
                _vm.listeners
              ),
              [_vm._v(_vm._s(_vm.value))]
            )
          : _c(
              "input",
              _vm._g(
                _vm._b(
                  {
                    ref:
                      typeof _vm.inputRef !== "undefined" ? _vm.inputRef : null,
                    staticClass: "form-control",
                    class: [
                      { valid: _vm.value && !_vm.error },
                      _vm.inputClasses
                    ],
                    attrs: {
                      type: _vm.type,
                      "aria-describedby": "addon-right addon-left"
                    },
                    domProps: { value: _vm.value }
                  },
                  "input",
                  _vm.$attrs,
                  false
                ),
                _vm.listeners
              )
            )
      ]),
      _vm._v(" "),
      _vm.addonRightIcon || _vm.$slots.addonRight
        ? _c(
            "span",
            { staticClass: "input-group-addon input-group-append" },
            [_vm._t("addonRight", [_c("i", { class: _vm.addonRightIcon })])],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("infoBlock"),
      _vm._v(" "),
      _vm._t("helpBlock", [
        _vm.error
          ? _c(
              "div",
              {
                staticClass: "text-danger invalid-feedback",
                class: { "mt-2": _vm.hasIcon },
                staticStyle: { display: "block" }
              },
              [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aa0f256", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa0f256","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inputs/formGroupInput.vue
// module id = j57n
// module chunks = 4